"use client";

/**
 * The /elan header action: watch this listing (owner, 2026-10-02: the
 * link out to the source site "is probably not nice", a page should give
 * a reason to stay). Watching is the same rose heart as on every card;
 * a price change on a watched listing is what we notify about.
 */
import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import SaveCelebration from "@/components/SaveCelebration";
import { useWatchlist } from "@/lib/use-watchlist";
import { useAuth } from "@/lib/auth-context";
import { isPushEligible } from "@/lib/push";
import { telegramBotHref } from "@/lib/telegram";
import { useT } from "@/lib/locale-context";
import { trackEvent } from "@/lib/tracking";
import { telegramWatchMarked, watchViaTelegram } from "@/components/seo/ListingStickyCta";

export default function ListingSaveButton({ id }: { id: string }) {
  const t = useT();
  const { user } = useAuth();
  const { has, toggle } = useWatchlist();
  const [burst, setBurst] = useState(0);
  // Signed out without push (an iOS Safari tab): the heart goes through
  // the Telegram bot, the same hand-off as the sticky bar.
  const [push, setPush] = useState(true);
  const [tg, setTg] = useState(false);
  useEffect(() => {
    setPush(isPushEligible());
    setTg(telegramWatchMarked(id));
  }, [id]);
  const watched = has(id) || tg;
  return (
    <button
      type="button"
      aria-pressed={watched}
      onClick={() => {
        if (tg) {
          window.open(telegramBotHref(), "_blank", "noopener");
          return;
        }
        if (!user && !push) {
          if (watchViaTelegram(id, "elan")) {
            setBurst(Date.now());
            setTg(true);
          }
          return;
        }
        if (!watched) setBurst(Date.now());
        trackEvent("listing.watch", { id, on: !watched, src: "elan" });
        void toggle(id);
      }}
      className={`relative inline-flex shrink-0 items-center justify-center gap-2 rounded-xl border px-4 py-2.5 text-sm font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2 ${
        watched
          ? "border-rose-200 bg-rose-50 text-rose-700 hover:bg-rose-100"
          : "border-gray-200 bg-white text-gray-900 hover:border-gray-300"
      }`}
    >
      <Heart key={burst} className={`h-4 w-4 ${burst ? "save-pop" : ""} ${watched ? "fill-rose-500 text-rose-500" : "text-gray-500"}`} aria-hidden />
      <span>{tg ? t("watchlist.telegram_on") : watched ? t("watchlist.watching") : !user && !push ? t("watchlist.telegram") : t("watchlist.add")}</span>
      <SaveCelebration burstKey={burst} color="#f43f5e" praise={t("watchlist.praise")} />
    </button>
  );
}
